<template>
  <div class="flex flex-col home vld-parent">
    <loading :active.sync="isLoading" :is-full-page="true" />
    <h2 class="mt-4 text-2xl text-center">Area {{ activeArea.name }}</h2>
    <div :key="Object.keys(drops).length" class="flex flex-col items-center flex-grow mx-2 mt-4">
      <div
        v-for="(store, index) in Object.values(drops)"
        :key="index"
        class="flex flex-col items-center justify-between w-full px-2 py-4 mb-5 text-center border border-gray-200 shadow-lg rounded-md"
      >
        <span class="mb-3 font-semibold">
          {{ store.address }}
        </span>
        <div
          v-for="(drop, i) in store.drops"
          :key="i"
          class="flex flex-col items-center justify-between w-full px-6 py-4 mb-4 text-xs text-center bg-gray-100 border border-gray-100 shadow rounded-md"
        >
          <div class="flex flex-col w-full my-2 md:w-1/3 md:text-left">
            <span class="font-light tracking-wide uppercase">
              {{ drop.name }}
            </span>
            <span class="tracking-wider text-gray-500">
              {{ drop.upc }}
            </span>
          </div>
          <div class="flex flex-col w-full my-2 md:text-right md:w-1/3">
            <span
              class="flex justify-center h-12 mt-3 mb-3 text-red-700 lg:h-8 lg:-mt-3 lg:justify-end"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                class="h-full"
                @click="deleteDrop(drop)"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                />
              </svg>
            </span>
            <span class="font-light tracking-wide uppercase"> ${{ drop.price }} </span>
            <span class="tracking-wider text-gray-500">
              {{
                new Date(drop.createdAt).toLocaleString(
                  {},
                  { dateStyle: 'medium', timeStyle: 'short' },
                )
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import REMOVE_DROP from '@/graphql/RemoveDrop';
import DROP_BY_STORE from '../graphql/GetDropsByStore';

export default {
  name: 'AreaDetail',
  data() {
    return {
      drops: {},
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters(['activeArea']),
  },
  methods: {
    // eslint-disable-next-line
    async deleteDrop({ _id }, storeIndex) {
      this.$modal.show('dialog', {
        text: 'Are you sure you want to remove this product?',
        buttons: [
          {
            title: 'Yes, remove!',
            handler: async () => {
              try {
                this.isLoading = true;
                await this.$apollo.mutate({
                  mutation: REMOVE_DROP,
                  variables: { id: _id },
                  // eslint-disable-next-line
                  update: (_) => {
                    const k = Object.keys(this.drops)[storeIndex];
                    const oldList = this.drops[k].drops;

                    const index = oldList.findIndex(
                      (e) => e._id === _id, // eslint-disable-line no-underscore-dangle
                    );
                    this.drops[k].drops.splice(index, 1);
                  },
                });
                this.isLoading = false;
                this.$toasted.success('Removed drop!', {
                  theme: 'bubble',
                  position: 'top-center',
                  duration: 3000,
                });
              } catch (error) {
                console.log(error);
                this.$toasted.error('Error removing the drop!', {
                  theme: 'bubble',
                  position: 'top-center',
                  duration: 3000,
                });
              } finally {
                this.$modal.hide('dialog');
              }
            },
          },
          {
            title: 'No.', // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.
            handler: () => {
              this.$modal.hide('dialog');
            }, // Button click handler
          },
        ],
      });
    },
  },
  async created() {
    this.isLoading = true;
    const { stores } = this.activeArea;
    await stores.forEach(async (store) => {
      const {
        data: { DropMany },
      } = await this.$apollo.query({
        query: DROP_BY_STORE,
        variables: { store },
      });
      if (DropMany.length > 0) {
        const storeAddress = DropMany[0].address;
        this.drops[store] = { address: storeAddress, drops: DropMany };

        this.$forceUpdate();
      }
    });
    this.isLoading = false;
  },
};
</script>

<style></style>
